module.exports = __webpack_public_path__ + "img/tartinerouge_off.e7058242.gif";